<template>
  <LetterLayout :model="model" v-on="$attrs" only-show-seal-in-from hide-indents date-alignment="start">

    <template #subject>
      <div class="fw-bold">
        <template v-if="first">
          RE: NOTICE OF VIOLATION OF SHORT-TERM RENTAL REGISTRATION REQUIREMENT AT {{ model.addressFormatted?.toUpperCase() }}
        </template>
        <template v-else>
          RE: SECOND NOTICE OF VIOLATION OF SHORT-TERM RENTAL REGISTRATION REQUIREMENT AT {{ model.addressFormatted?.toUpperCase() }}
        </template>
      </div>
    </template>

    <template #footer>
      <div class="d-flex flex-column gap-1 align-items-center text-primary mb-5">
        <div class="fw-bold">TOWN OF FALMOUTH</div>
        <div>271 Falmouth Road | Falmouth, ME 04105</div>
        <div>www.falmouthme.org</div>
      </div>
    </template>

    <p>
      Dear {{ model.ownerFormatted }},
    </p>
    <template v-if="first">
      <p>
        You are hereby notified as owner of the above referenced property that the property is in violation of
        Ch. II-23 of the Falmouth Code of Ordinances, “Short-term Rental Ordinance.”
      </p>
      <p>
        Pursuant to the Short-term Rental Ordinance, effective January 1, 2022, no person shall advertise, operate, or rent
        a short-term rental in the Town of Falmouth without first registering the short-term rental with the Town. Short-term
        rental is defined as the advertising, offering for rent, use, control, management, or operation of a dwelling unit in
        whole or in part, for dwelling, sleeping, or lodging purposes for a period of less than thirty consecutive days, for
        compensation, directly or indirectly.
      </p>
      <p>
        The Town’s records indicate that you are currently advertising, operating, and/or renting a short-term rental at the
        above referenced property without first having obtained a short-term rental registration. To remedy this violation,
        please either register your property as a short-term rental, or cease advertising, operating, and/or renting this
        property as a short-term rental.
      </p>
      <p>
        The Town is utilizing a permitting software in partnership with STR Enforcement, LLC, to register short-term
        rentals. To register your property please visit: https://app.strenforcement.com/register/falmouth_me. Town staff
        are happy to assist you with this process. Please email str@falmouthme.org or call Julie Baxter at (207) 699-5335.
      </p>
      <p class="fw-bold">
        Please be advised that the penalty for advertising, operating, and/or renting a short-term rental without a
        valid registration is a per day fine of $1,000 for the first offense and an additional per day fine of $1,500 for
        each additional offense, to be recovered upon complaint to Maine District Court or Superior Court.
      </p>
      <div>
        A short-term rental shall not be considered registered until:
        <ol>
          <li>Application and all associated documentation have been provided to the satisfaction of the Town;</li>
          <li>$300 registration fee has been received by the Town; and</li>
          <li>Registration number has been assigned to the unit.</li>
        </ol>
      </div>
      <p>
        Registration must be renewed annually on or before January 1. <b>It is the responsibility of the owner to make sure
        that the required information is always kept current and to notify the Town of any changes.</b> A copy of the
        ordinance is enclosed for reference.
      </p>
      <p>
        If you have questions regarding the Short-term Rental Ordinance violation, please email str@falmouthme.org or call
        Julie Baxter at (207) 699-5335.
      </p>
    </template>
    <template v-else>
      <p>
        You are hereby notified as owner of the above referenced property that the property is in violation of
        Ch. II-23 of the Falmouth Code of Ordinances, “Short-term Rental Ordinance.”
      </p>
      <p>
        Pursuant to the Short-term Rental Ordinance, effective January 1, 2022, no person shall advertise, operate, or
        rent a short-term rental in the Town of Falmouth without first registering the short-term rental with the Town.
        Short-term rental is defined as the advertising, offering for rent, use, control, management, or operation of a
        dwelling unit in whole or in part, for dwelling, sleeping, or lodging purposes for a period of less than thirty
        consecutive days, for compensation, directly or indirectly.
      </p>
      <p>
        On {{ model.dateOfLastLetterFormatted }}, the Town sent you a notice of violation for advertising, operating,
        and/or renting the above referenced property as a short-term rental without first having obtained a short-term
        rental registration from the Town. To date, you have failed to address this violation.
      </p>
      <p>
        Effective immediately you must either register your property with the Town or discontinue advertising,
        operating and/or renting your property on a short-term basis, cancel any existing reservations, and remove any
        advertisements pertaining to the short-term rental of the property.
      </p>
      <p>
        The Town is utilizing a permitting software, in partnership with STR Enforcement, LLC, to register
        short-term rentals. To register your property, please visit: https://app.strenforcement.com/register/falmouth_me.
      </p>
      <div>
        A short-term rental shall not be considered registered until:
        <ol>
          <li>
            Application and all associated documentation have been provided to the satisfaction of the Town;
          </li>
          <li>
            $300 registration fee has been received by the Town; and
          </li>
          <li>
            Registration number has been assigned to the unit.
          </li>
        </ol>
      </div>
      <p>
        Registration must be renewed annually on or before January 1. <b>It is the responsibility of the owner to make
        sure that the required information is always kept current and to notify the Town of any changes.</b> A copy
        of the ordinance is enclosed for reference.
      </p>
      <p class="fw-bold">
        Please be advised that the penalty for operating and/or advertising the rental of a short-term rental
        without a valid registration is a per day fine of $1,000 for the first offense and an additional per day fine
        of $1,500 for each additional offense, to be recovered upon complaint to Maine District Court or
        Superior Court.
      </p>
      <p>
        Should you fail address the violations referenced above within 30 days, then the Town will pursue an
        enforcement action against you in Maine District or Superior Court. Should the Town prevail in any enforcement
        action against you, it will be entitled to recover penalties in the amounts described above, its
        costs for pursuing the enforcement action against you, and its attorney’s fees.
      </p>
      <p>
        If you have questions regarding the Short-term Rental Ordinance violation, please email str@falmouthme.org
        or call Julie Baxter at (207) 699-5335.
      </p>
    </template>
  </LetterLayout>
</template>

<script>
import LetterLayout from "@/components/letters/LetterLayout.vue";
import {LetterContext} from "@/models/letterContext";

export default {
  components: {LetterLayout},
  props: {
    model: LetterContext,
    first: Boolean
  }
}
</script>
